import React, { useCallback } from 'react'

import { useKeyboardNavigation } from '../../../../hooks/useKeyboardNavigation'
import { AddressSuggestedPlacesItem } from '../AddressSuggestedPlacesItem'
import * as Styled from './styled'

export type PredictedPlace = google.maps.places.AutocompletePrediction

export interface AddressSuggestedPlacesProps {
  suggestedPlaces: PredictedPlace[]
  onPlaceSelection: (place: PredictedPlace) => PredictedPlace | void
  isDisabled: boolean
}

export const AddressSuggestedPlaces: React.VFC<AddressSuggestedPlacesProps> = ({
  suggestedPlaces,
  onPlaceSelection,
  isDisabled,
}) => {
  const onSelection = useCallback(
    (index: number) => {
      const place = suggestedPlaces[index]
      if (!place) {
        return
      }
      onPlaceSelection(place)
    },
    [suggestedPlaces, onPlaceSelection],
  )

  const { selectedIndex, onMouseOver } = useKeyboardNavigation({
    listLength: suggestedPlaces.length,
    onSelection,
  })

  return suggestedPlaces ? (
    <Styled.Container
      // Keep Safari/WebKit from dropping focus on button click. This convinces Safari to "catch"
      // focus on the container instead of on a parent element outside of the form (e.g. top-level
      // Router).
      // - https://bugs.webkit.org/show_bug.cgi?id=229895
      tabIndex={-1}
    >
      <Styled.SuggestionList>
        {suggestedPlaces.map((place, index) => {
          return (
            <AddressSuggestedPlacesItem
              key={place.place_id || index}
              onPlaceSelection={onPlaceSelection}
              isDisabled={isDisabled}
              isSelected={selectedIndex === index}
              place={place}
              onFocusOrMouseOver={onMouseOver(index)}
            />
          )
        })}
      </Styled.SuggestionList>
    </Styled.Container>
  ) : null
}
